import React, {Component} from 'react';
import Select from 'components/common/select/Select.component';
import UserSearch from '../input/UserSearch.component';

export class EditableEmails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: props.value
        };

        this.changeSelectedValue = this.changeSelectedValue.bind(this);
    }

    changeSelectedValue(value) {
        this.setState({
            selectedValue: value
        });

        this.props.changeValue(value, this.props.index);
    }

    render() {
        return (
            <UserSearch propagateValue={this.changeSelectedValue}
                        includeSameUser={true}
                        value={this.state.selectedValue}
                        stopFocus={true}
                        multi={true}
                        menuPlacement={"auto"}
                        menuPortalTarget={document.body}
                        translate={this.props.translate}/>
        );
    }
}


export class EditableDimension extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: props.value
        };
        this.changeSelectedValue = this.changeSelectedValue.bind(this);
    }

    changeSelectedValue(value) {
        this.setState({
            selectedValue: value
        });

        this.props.changeValue(value, this.props.index);
    }


    render() {
        return (
            <Select
                isClearable={false}
                menuShouldScrollIntoView={true}
                isMulti={false}
                onBlurResetsInput={false}
                onCloseResetsInput={false}
                menuPlacement={"auto"}
                menuPortalTarget={document.body}
                isSearchable={true}
                maxMenuHeight={100}
                value={this.state.selectedValue}
                showNoOptions={true}
                options={this.props.options}
                onChange={this.changeSelectedValue}
                translate={this.props.translate}
            />
        );
    }
}